export const CHECKOUT_URL =
  'https://atlas-de-viajes.impultienda.ar/checkout/europa-por-primera-vez'

export type Pricing = {
  currency: 'ARS' | 'USD'
  priceNow: string
  priceBefore: string
}

export const PRICING: Record<'AR' | 'INTL', Pricing> = {
  AR: { currency: 'ARS', priceNow: 'ARS 29.990', priceBefore: 'ARS 59.990' },
  INTL: { currency: 'USD', priceNow: 'USD 19.99', priceBefore: 'USD 39.99' },
}

export const PRODUCT = {
  name: 'Europa por Primera Vez',
  brand: 'Atlas de Viajes',
  coverImage:
    'https://cdn.magicpatterns.com/uploads/pDACVAmWpVxPzdzBJsBmpw/EUROPA_POR_PRIMERA_VEZ.png',
  logo: 'https://cdn.magicpatterns.com/uploads/iAxStmassZSeCqDBnY2DFn/LOGO_ATLAS.png',
  caroPhoto: 'https://cdn.magicpatterns.com/uploads/fYrYvrmbdfCMiqBJEL9tyV/CARO.png',
}

export const heroBenefits = [
  'Ruta e itinerario organizados.',
  'Presupuesto bajo control.',
  'Consejos para vuelos, alojamientos y transporte.',
  'Reservas y documentación ordenadas.',
  'Herramientas editables listas para usar.',
]

export const problemCards = [
  'Tengo demasiadas ciudades guardadas y no sé cómo combinarlas.',
  'No sé cuánto dinero necesito realmente.',
  'Encuentro precios y consejos diferentes en todos lados.',
  'No sé qué debería reservar primero.',
  'Tengo miedo de olvidarme algo importante.',
  'Quiero hacerlo por mi cuenta, pero necesito una estructura.',
]

export const pillars = [
  {
    label: 'Planificá',
    text: 'Definí destinos, cantidad de días, alojamiento, transporte y reservas sin empezar desde cero.',
  },
  {
    label: 'Organizá',
    text: 'Centralizá gastos, vuelos, actividades, documentación e itinerario con herramientas editables.',
  },
  {
    label: 'Viajá mejor',
    text: 'Evitá errores frecuentes y tomá decisiones más inteligentes antes de gastar.',
  },
]

export const valueStats = [
  '+120 páginas de contenido práctico',
  '19 rutas recomendadas',
  '8 recursos digitales',
  'Plantillas editables',
]

export const resultBenefits = [
  'Organizar una ruta que tenga lógica.',
  'Entender mejor cuánto dinero necesitás.',
  'Comparar opciones antes de reservar.',
  'Encontrar vuelos con más criterio.',
  'Saber qué entradas conviene comprar antes.',
  'Evitar gastos que podrían haberse prevenido.',
  'Tener reservas y documentación ordenadas.',
  'Viajar con un itinerario claro, pero flexible.',
]

export const purchaseIncludes = [
  'Guía completa de planificación.',
  '19 rutas recomendadas.',
  'Plantillas editables.',
  'Planner de presupuesto.',
  'Checklist pre-viaje.',
  'Apps y herramientas.',
  'Guía de errores caros.',
  'Equipaje inteligente.',
]
